<script>
import Swal from "sweetalert2";
import {required} from "vuelidate/lib/validators"; 
import store from "@/state/store"; 
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Drawer from "vue-simple-drawer";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrBirimButceHarcamalari from "@/models/StrBirimButceHarcamalari";
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiAnaBirim.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import AddEdit from "./AddEdit.vue";
import Print from "./Print.vue";
import moment from "moment";
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';

const simulateAsyncOperation = fn => {
  setTimeout(fn, 500)
}

export default {
  mixins: [Api, Sabit, StrBirimButceHarcamalari],
  page: {
    title: "Harcama Giriş",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Drawer,
    Layout,
    PageHeader,
    AddEdit,
    formcombobox,
    Print,
    BirimSecimi,
    Treeselect
  },
  data() {
    return {
      title: this.$t("StrBirimButceHarcamalari.Title"),
      items: [
        {
          text: this.$t("StrBirimButceHarcamalari.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("StrBirimButceHarcamalari.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("StrBirimButceHarcamalari.Title"),
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      Page2: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      FilitrelemePenceresi: false,
      TableData: {},
      DataUpdate: "",
      GetAll: false,
      DataPrint: "",
      AddEdit: "",
      aktif_yil:null,
      TableDataTutarlar: [],
      ComboBoxBirimId: [],
      ComboBoxHesapkodlariid: [],
      ComboBoxDonemId: [],
      ComboBoxStrAmacId: [],
      ComboBoxPerformanHedef: [],
      ComboBoxStratejikFaliyet: [],
      ComboBoxHarcamaTipi: [],
      ComboBoxIhaleTipi: [],
      ComboBoxVeriGirisiYapan: [],
      ComboBoxGerceklestirmeGorevlisi: [],
      ComboBoxDonem: [],
      ComboBoxOnay: [
        { Id: "True", Value: "Onaylı" },
        { Id: "False", Value: "Onaysız" },
      ],
      ComboBoxStrPerformansHedefiId: [],
      Filter: {
        StrDonemId: null,
        Donem: null,
        Onay: null,
        StrAmacId: null,
        StrPerformansHedefiId: null,
        BirimId: null,
        Hesapkodlariid: null
      },
      siralama:"&Asc=Onay&Desc=Tarih",

      Tarih: moment(new Date()).format("YYYY-MM-DD"),
      uri: "data:application/vnd.ms-excel;base64,",
      template:
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
      base64: function (s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function (s, c) {
        return s.replace(/{(\w+)}/g, function (m, p) {
          return c[p];
        });
      },
    };
  },
  validations: {
    Filter: {
      StrDonemId: {},
      Donem: {required},
      Onay: {},
      StrAmacId: {},
      StrPerformansHedefiId: {},
      BirimId:{},
      Hesapkodlariid: {}
    },
  },

  methods: {
    Get() {
      this.$v.$touch();
          if (!this.$v.$invalid) { 
            if(this.GetAll != true){


              let Filter = "";
              if (this.Filter.StrDonemId!=null && this.Filter.StrDonemId!="") Filter = Filter + "&StrDonemId=" + this.Filter.StrDonemId;
              if (this.Filter.Onay!=null && this.Filter.Onay!="") Filter = Filter + "&Onay=" + this.Filter.Onay;
              if (this.Filter.StrAmacId!=null && this.Filter.StrAmacId!="") Filter = Filter + "&StrAmacId=" + this.Filter.StrAmacId;
              if (this.Filter.StrPerformansHedefiId!=null && this.Filter.StrPerformansHedefiId!="") Filter = Filter + "&StrPerformansHedefiId=" + this.Filter.StrPerformansHedefiId;
              if (this.Filter.BirimId!=null && this.Filter.BirimId!="") Filter = Filter + "&BirimId=" + this.Filter.BirimId;
              if (this.Filter.Donem!=null && this.Filter.Donem!="") Filter = Filter + "&Donem=" + this.Filter.Donem;
              if (this.Filter.Hesapkodlariid!=null && this.Filter.Hesapkodlariid!="") Filter = Filter + "&Hesapkoduid=" + this.Filter.Hesapkodlariid;

              if(this.siralama!=null && this.siralama!=""){
                Filter=Filter+this.siralama;
              }

            this.ActionsFilterGet({
                Service: "StrBirimButceHarcamalari",
                Page: this.Page,
                Filter: Filter,
              }).then((res) => {
                this.TableData = res.Data;
                this.Page.PageDataSize = res.TotalCount;

                this.FilitrelemePenceresi = false;
                
              }); 

            }else{

              let Filter = "";
              if (this.Filter.StrDonemId!=null && this.Filter.StrDonemId!="") Filter = Filter + "&StrDonemId=" + this.Filter.StrDonemId;
              if (this.Filter.Onay!=null && this.Filter.Onay!="") Filter = Filter + "&Onay=" + this.Filter.Onay;
              if (this.Filter.StrAmacId!=null && this.Filter.StrAmacId!="") Filter = Filter + "&StrAmacId=" + this.Filter.StrAmacId;
              if (this.Filter.StrPerformansHedefiId!=null && this.Filter.StrPerformansHedefiId!="") Filter = Filter + "&StrPerformansHedefiId=" + this.Filter.StrPerformansHedefiId;
              if (this.Filter.BirimId!=null && this.Filter.BirimId!="") Filter = Filter + "&BirimId=" + this.Filter.BirimId;
              if (this.Filter.Donem!=null && this.Filter.Donem!="") Filter = Filter + "&Donem=" + this.Filter.Donem;
              if (this.Filter.Hesapkodlariid!=null && this.Filter.Hesapkodlariid!="") Filter = Filter + "&Hesapkoduid=" + this.Filter.Hesapkodlariid;

              if(this.siralama!=null && this.siralama!=""){
                Filter=Filter+this.siralama;
              }

            this.ActionsFilterGet({
                Service: "StrBirimButceHarcamalari",
                Page: this.Page2,
                Filter: Filter,
              }).then((res) => {
                this.TableData = res.Data;
                this.Page2.PageDataSize = res.TotalCount;

                this.FilitrelemePenceresi = false;
                
              }); 
            }   
        }
    },
    loadOptions({ action,  callback }) {
      this.options=[];
      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {

           this.options = this.ComboBoxHesapkodlariid;

          callback(null, this.options)
        })
      }
    },
    ExcelExport(table, name){  

      setTimeout(() => {
      
          if (!table.nodeType) table = this.$refs.StrBirimButceHarcamalari;
          var html =table.innerHTML  
          var ctx = {worksheet: name || 'Worksheet', table:html }
          var a = document.createElement('a');
          a.href = this.uri +this.base64(this.format(this.template, ctx));
          a.download = name + '.xls';
          a.click();  
      
      }, 1000);

      }, 
    Onay(Data) {

      Swal.fire({
        title: this.$t("StrBirimButceHarcamalari.ToasMessage.Baslik"),
        text: this.$t("StrBirimButceHarcamalari.ToasMessage.Content"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: this.$t("StrBirimButceHarcamalari.ToasMessage.Pozitif"),
        cancelButtonText: this.$t("StrBirimButceHarcamalari.ToasMessage.Negatif"),
      }).then((result) => {
        if (result.value) {


          let Page = {
        PageNumber: "1",
        PageSize: "1",
        PageDataSize: "1",
      };
      let Filter = "&Desc=Sira&Onay=true&Donem=" + Data.Donem;
      this.ActionsFilterGet({
        Service: "StrBirimButceHarcamalari",
        Page: Page,
        Filter: Filter,
      }).then((res) => {
        var Sira = 1;
        if (res.Data.length > 0) {
          Sira = res.Data[0].Sira + 1;
        }
        Data.Sira = Sira;
        Data.Onay = true;
        this.Update("StrBirimButceHarcamalari", Data).then((res) => {
          if (res) {
            this.Get();
          }
        });
      });
      
        }
      });


    },
    Onayiptal(Data) {

          Swal.fire({
            title: this.$t("StrBirimButceHarcamalari.ToasMessage.IptalBaslik"),
            text: this.$t("StrBirimButceHarcamalari.ToasMessage.IptalContent"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            confirmButtonText: this.$t("StrBirimButceHarcamalari.ToasMessage.IptalPozitif"),
            cancelButtonText: this.$t("StrBirimButceHarcamalari.ToasMessage.IptalNegatif"),
          }).then((result) => {
            if (result.value) {


              let Page = {
            PageNumber: "1",
            PageSize: "1",
            PageDataSize: "1",
          };
          let Filter = "&Desc=Sira&Onay=true&Donem=" + Data.Donem;
          this.ActionsFilterGet({
            Service: "StrBirimButceHarcamalari",
            Page: Page,
            Filter: Filter,
          }).then((res) => {
            var Sira = 1;
            if (res.Data.length > 0) {
              Sira = res.Data[0].Sira + 1;
            }
            Data.Sira = Sira;
            Data.Onay = false;
            this.Update("StrBirimButceHarcamalari", Data).then((res) => {
              if (res) {
                this.Get();
              }
            });
          });

            }
          });


      },
    PerformanHedefSecimi() {
      this.ComboBoxStratejikFaliyet = [];
      this.FormData.ComboBoxStrPerformansHedefiId = "";
      this.ComboBoxPerformanHedef = [];
      this.FormData.Strperformanshedefiid = "";
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      let Filter = "&AmacId=" + this.FormData.Stramacid;
      this.ActionsFilterGet({
        Service: "StrPerfTablo",
        Page: Page,
        Filter: Filter,
      }).then((res) => {
        this.ComboBoxPerformanHedef = res.Data;
      });
    },
    StratejikFaaliyetSecimi() {
      this.ComboBoxStratejikFaliyet = [];
      this.FormData.ComboBoxStrPerformansHedefiId = "";
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      let Filter = "&Tabloids=" + this.FormData.Strperformanshedefiid;
      this.ActionsFilterGet({
        Service: "StrPerfTablolarDetay",
        Page: Page,
        Filter: Filter,
      }).then((res) => {
        this.ComboBoxStratejikFaliyet = res.Data;
      });
    },
    PerformanHedefSecimiFilter() {
      this.ComboBoxStrPerformansHedefiId = [];
      this.Filter.StrPerformansHedefiId = "";
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      let Filter = "&AmacId=" + this.Filter.StrAmacId;
      this.ActionsFilterGet({
        Service: "StrPerfTablo",
        Page: Page,
        Filter: Filter,
      }).then((res) => {
        for (var i = 0; i < res.Data.length; i++) {
          this.ComboBoxStrPerformansHedefiId.push({
            Id: res.Data[i].Id,
            Value: res.Data[i].Adi,
          });
        }
      });
    },
    rightDrawer() {
      this.FilitrelemePenceresi = !this.FilitrelemePenceresi;
      this.Filter.Hesapkodlariid = null;
    },
    yetki_kontrol(yetki){

      var sonuc = this.KullaniciBilgileri.indexOf(yetki);

      return sonuc;

      },
      liste_yukle(veri){
      let Page = {
        PageNumber: "1",
        PageSize: "50",
      };

      if (veri.length>=1){

          this.ComboBoxHesapkodlariid=[];

          let Filter ="";
          if(veri[0]=="0" && veri[2]=="."){
            Filter = "&Basamak=4&KodForLike="+veri;
          } else {
          
          Filter = "&Basamak=4&Aciklama="+veri;
          }

          this.ActionsFilterGet({Service:"StrHesapKodlari",Page:Page, Filter:Filter}).then(res => {  
            for(var i=0; i<res.Data.length; i++)
              {
                this.ComboBoxHesapkodlariid.push ({id:res.Data[i].Id,label:res.Data[i].Kod + " - " + res.Data[i].Aciklama})
              }    
          }); 

      }

    },
  },
  created() {
    let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };

    this.KullaniciBilgileri = store.getters.["auth/UserRolles"];

    this.ActionsGet({ Service: "OBirim", Page: Page }).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.ComboBoxBirimId.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].BirimAdi,
        });
      }
    });
    this.ActionsGet({ Service: "StrHesapKodlari", Page: Page }).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.ComboBoxHesapkodlariid.push({
          id: res.Data[i].Id,
          label: res.Data[i].Aciklama,
        });
      }
    });


/*
    this.ActionsFilterGet({
      Service: "StrPerfDonem",
      Page: Page,
      Filter: "&TipId=04691b9c-20f4-41e2-a339-35638fcd8c5e&Approval=true",
    }).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        if (this.$options.filters.formatDate(res.Data[i].BaslamaTarihi) <= this.Tarih && this.Tarih <= this.$options.filters.formatDate(res.Data[i].BitisTarihi)) {
          if (!res.Data[i].UstId) {
            this.ComboBoxDonemId.push({
              Id: res.Data[i].Id,
              Value: res.Data[i].Aciklama,
            });

        
          }
        }
      }
    });
*/

    let sorgu = "&Tip=1561";
          let Tip=[];
            
            this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:sorgu}).then((res) => {
             // console.log(res)
                for(var i=0; i<res.Data.length; i++)
                {   
                    if(res.Data[i].Kod==1 || res.Data[i].Kod==2 ) { 
                        Tip.push(res.Data[i].Id);       
                    }            
                }

                let altsorgu="&UstIdDoluMu=false&Approval=true";

                let tipler="";

                for (var s=0; s<Tip.length; s++){

                    tipler=tipler+"&TipId="+Tip[s];

                }

                altsorgu=altsorgu+tipler;

             

                this.ActionsFilterGet({ Service: "StrPerfDonem", Page: Page, Filter: altsorgu }).then((res) => {
                for (var i = 0; i < res.Data.length; i++) {
            
                  if (this.$options.filters.formatDate(res.Data[i].BaslamaTarihi) <= this.Tarih && this.Tarih <= this.$options.filters.formatDate(res.Data[i].BitisTarihi)) {
       
                  this.ComboBoxDonemId.push ({Id:res.Data[i].Id,Value:res.Data[i].Aciklama})
                  }
                  
                }
              });
         
            });





        let yil=new Date().getFullYear()
    for (var i = yil-2; i < yil+5; i++) {
      this.ComboBoxDonem.push({
        Id: i,
        Value: i,
      });
    }

    this.ActionsGet({ Service: "StrStratejikAmac", Page: Page }).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.FormDataType.Stramacid.ComboDataArray.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].Aciklama,
        });

        this.ComboBoxStrAmacId.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].Aciklama,
        });
      }
    });
    this.ActionsGet({ Service: "StrStratejikAmac", Page: Page }).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.ComboBoxStrAmacId.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].Aciklama,
        });
      }
    });


    this.aktif_yil = yil;
    if(this.aktif_yil != null && this.aktif_yil != "" ){
      this.Filter.Donem = this.aktif_yil;
       
      this.FilterGet();

    }
       


  },
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />

      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4"></div>
                <div class="col-sm-8">
                  <div class="text-sm-end">
                    <button type="button" class="btn btn-secondary btn-rounded mb-2 me-2" @click="rightDrawer">
                      <i class="mdi mdi-text-search me-1"></i>
                      {{ $t("StrBirimButceHarcamalari.Page.Filtreleme") }}
                    </button>
                    <button type="button" class="btn btn-warning btn-rounded mb-2 me-2" @click="GetAll = !GetAll, Get()">
                      <i class="mdi mdi-download me-1"></i>
                     Tümünü Getir
                    </button>
                  
                          <button
                            type="button"
                            class="btn btn-success btn-rounded mb-2 me-2"
                            @click="
                              ExcelExport(
                                'Harcama Giriş',
                                'Harcama Giriş',
                              )
                            "
                          >
                            <i class="mdi mdi-file-export-outline me-1"></i>
                            Excel'e Aktar
                          </button>
                    <button type="button" class="btn btn-primary btn-rounded mb-2 me-2" v-b-modal.StrBirimButceHarcamalari @click="(DataUpdate = StrBirimButceHarcamalariData), (AddEdit = 'Add')">
                      <i class="mdi mdi-plus me-1"></i>
                      {{ $t("StrBirimButceHarcamalari.Page.YeniKayitEkle") }}
                    </button>
                  </div>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table mb-0" ref="StrBirimButceHarcamalari">
                  <thead class="table-light">
                    <tr>
                      <th>{{ $t("StrBirimButceHarcamalari.Table.Baslik") }}
                       <i style="margin-left:10px" v-if="siralama!='&Asc=Baslik'" @click="siralama='&Asc=Baslik', Get()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=Baslik'" @click="siralama='&Desc=Baslik', Get()" class="bx bx-sort-z-a  fa-xl"></i>
                   </th>
                      <th>
                        {{ $t("StrBirimButceHarcamalari.Table.BirimAdi") }}
                         <i style="margin-left:10px" v-if="siralama!='&Asc=BirimAdi'" @click="siralama='&Asc=BirimAdi', Get()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=BirimAdi'" @click="siralama='&Desc=BirimAdi', Get()" class="bx bx-sort-z-a  fa-xl"></i>
                   
                      </th>
                      <th>{{ $t("StrBirimButceHarcamalari.Table.Amac") }}
                       <i style="margin-left:10px" v-if="siralama!='&Asc=Amac'" @click="siralama='&Asc=Amac', Get()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=Amac'" @click="siralama='&Desc=Amac', Get()" class="bx bx-sort-z-a  fa-xl"></i>
                   </th>
                      <th>
                        {{ $t("StrBirimButceHarcamalari.Table.IhaleUsulleriValue") }}
                         <i style="margin-left:10px" v-if="siralama!='&Asc=IhaleUsulleriValue'" @click="siralama='&Asc=IhaleUsulleriValue', Get()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=IhaleUsulleriValue'" @click="siralama='&Desc=IhaleUsulleriValue', Get()" class="bx bx-sort-z-a  fa-xl"></i>
                   
                      </th>
                      <th>
                        {{ $t("StrBirimButceHarcamalari.Table.HarcamaTipi") }}
                      </th>
                      <th>
                        {{ $t("StrBirimButceHarcamalari.Table.KdvsizTutar") }}
                      </th>
                      <th>
                        {{ $t("StrBirimButceHarcamalari.Table.KdvTutari") }}
                      </th>
                      <th>
                        {{ $t("StrBirimButceHarcamalari.Table.ToplamTutar") }}
                      </th>
                      <th>
                        {{ $t("StrBirimButceHarcamalari.Table.Duzeltmenotu") }}
                      </th>
                      <th>
                        {{ $t("StrBirimButceHarcamalari.Table.Tarih") }}
                      </th>
                      <th>{{ $t("StrBirimButceHarcamalari.Table.Onay") }}</th>
                      <th style="width: 85px; text-align: center;">{{ $t("StrBirimButceHarcamalari.Table.Islem") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="TableDataVerileri in TableData" :key="TableDataVerileri.Id">
                      <th scope="row">{{ TableDataVerileri.Baslik }}</th>
                      <td>{{ TableDataVerileri.BirimAdi }}</td>
                      <td>{{ TableDataVerileri.Amac }}</td>
                      <td>{{ TableDataVerileri.IhaleUsulleriValue }}</td>
                      <td>{{ TableDataVerileri.HarcamaTipi }}</td>
                      <td>{{ TableDataVerileri.ToplamKdvsiz | TrParaFormat }}</td>
                      <td>{{ TableDataVerileri.ToplamKdv  | TrParaFormat}}</td>
                      <td>
                        {{ (TableDataVerileri.ToplamKdvsiz + TableDataVerileri.ToplamKdv) | TrParaFormat }}
                      </td>
                      <td>{{ TableDataVerileri.Duzeltmenotu }}</td>
                      <td>{{ TableDataVerileri.Tarih | formatDateTable}}</td>
                      <td style="vertical-align: middle; text-align: center;">
                        <i v-if="TableDataVerileri.Onay" class="fas fas fa-check"></i>
                        <i v-if="!TableDataVerileri.Onay" class="fas fas fa-times"></i>
                      </td>
                      <td style="width: 85px; text-align: center; vertical-align: middle;">
                        <b-button-group>

                          <b-button variant="success" 
                          v-if="!TableDataVerileri.Onay && TableDataVerileri.ToplamKdvsiz>0 && 
                          (yetki_kontrol('StrHarcamaGirisOnay')>=0  || yetki_kontrol('StrAdmin')>=0
                           || yetki_kontrol('SuperAdmin')>=0)" 
                            @click="Onay(TableDataVerileri)"><i class="fas fas fa-check-double"></i>
                          </b-button>

                          <b-button variant="warning" 
                          v-if="TableDataVerileri.Onay && (yetki_kontrol('StrHarcamaGirisOnay')>=0  || yetki_kontrol('StrAdmin')>=0
                           || yetki_kontrol('SuperAdmin')>=0)" 
                          @click="Onayiptal(TableDataVerileri)"><i class="fas fas fa-reply-all"></i>
                        </b-button>
                          <b-button variant="info" v-if="TableDataVerileri.Onay" v-b-modal.StrBirimButceHarcamalariYazdir @click="DataPrint = TableDataVerileri"><i class="fas fa-print"></i></b-button>
                          <b-button variant="primary" v-if="!TableDataVerileri.Onay && TableDataVerileri.Satdosyaid == null" v-b-modal.StrBirimButceHarcamalari @click="(DataUpdate = TableDataVerileri), (AddEdit = 'Edit')"><i class="fas fa-pencil-alt"></i></b-button>
                          <b-button variant="danger" v-if="(!TableDataVerileri.Onay) && TableDataVerileri.Satdosyaid == null" @click="Delete('StrBirimButceHarcamalari', TableDataVerileri.Id)"><i class="fas fa-trash-alt"></i></b-button>
                        </b-button-group>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage" :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table" @input="ChangePage(DefaultPage)"> </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddEdit :Id="DataUpdate" :AddEdit="AddEdit" v-show="AddEdit" @TableUpdate="Get()" />
      <Print :Id="DataPrint" v-show="DataPrint" />

      <Drawer @close="rightDrawer" :align="'right'" :closeable="true" :maskClosable="true" :zIndex="1002">
        <div style="width: 400px;" v-if="FilitrelemePenceresi">       
          <div class="offcanvas-header">         
            <h5 class="offcanvas-title" id="offcanvasExampleLabel">
              {{ $t("StrBirimButceHarcamalari.Filtreleme.Title") }}
            </h5>
          </div>
          <div class="offcanvas-body">
            {{ $t("StrBirimButceHarcamalari.Filtreleme.Content") }}

            <div class="mb-3">
              <formcombobox
                :FormDataType="{
                  FieldName: 'StrDonemId',
                  Field: 'combobox',
                  FieldTitle: $t('StrBirimButceHarcamalari.Filtreleme.StrDonemId'),
                  ComboDataArray: ComboBoxDonemId,
                }"
                :Value="Filter.StrDonemId"
                :v="$v.Filter.StrDonemId"
                @input="Filter.StrDonemId = $event"
              />
            </div>

            <div class="mb-3">
              <formcombobox
                :FormDataType="{
                  FieldName: 'Donem',
                  Field: 'combobox',
                  FieldTitle: $t('StrBirimButceHarcamalari.Filtreleme.Donem'),
                  ComboDataArray: ComboBoxDonem,
                }"
                :Value="Filter.Donem"
                :v="$v.Filter.Donem"
                @input="Filter.Donem = $event"
              />
            </div>
            <div class="mb-3">
              <formcombobox
                :FormDataType="{
                  FieldName: 'Onay',
                  Field: 'combobox',
                  FieldTitle: $t('StrBirimButceHarcamalari.Filtreleme.Onay'),
                  ComboDataArray: ComboBoxOnay,
                }"
                :Value="Filter.Onay"
                :v="$v.Filter.Onay"
                @input="Filter.Onay = $event"
              />
            </div>
            <div class="mb-3">
              <formcombobox
                :FormDataType="{
                  FieldName: 'StrAmacId',
                  Field: 'combobox',
                  FieldTitle: $t('StrBirimButceHarcamalari.Filtreleme.StrAmacId'),
                  ComboDataArray: ComboBoxStrAmacId,
                }"
                :Value="Filter.StrAmacId"
                :v="$v.Filter.StrAmacId"
                @input="(Filter.StrAmacId = $event), PerformanHedefSecimiFilter()"
              />
            </div>
            <div class="mb-3">
              <formcombobox
                :FormDataType="{
                  FieldName: 'StrPerformansHedefiId',
                  Field: 'combobox',
                  FieldTitle: $t('StrBirimButceHarcamalari.Filtreleme.StrPerformansHedefiId'),
                  ComboDataArray: ComboBoxStrPerformansHedefiId,
                }"
                :Value="Filter.StrPerformansHedefiId"
                :v="$v.Filter.StrPerformansHedefiId"
                @input="Filter.StrPerformansHedefiId = $event"
              />
            </div>
            <div class="mb-3">
            
  
                  <BirimSecimi
                    :title="$t('StrBirimButceHarcamalari.Filtreleme.BirimId')"
                    :sutun="'0'" 
                    :title_position="'mb-3'"
                    :selected="Filter.BirimId"
                    :labels_lg="'3'"  
                    :YetkiKontrol="1"
                    :multiple="false"
                    :BirimTipId="null"
                    @Secilmis_Idler="Filter.BirimId=$event"
                    :v="$v.Filter.BirimId"
                  />
         


            </div>
            <b-form-group class="mb-3" id="example text"  label="Tertibi" label-for="text">
        
        <treeselect 
        name="'cbhesapkodlari'"
        id="'cbhesapkodlari'"
        @search-change="liste_yukle($event)"
        :async="true"
        :load-options="loadOptions"
        :options="ComboBoxHesapkodlariid"
        :multiple="false"   
        searchPromptText="Aramak için yazın..."
        placeholder="Seçiniz..." 
        v-model="Filter.Hesapkodlariid"          
        />

        <treeselect-value :value="Filter.Hesapkodlariid" />
    </b-form-group>


            <b-button @click="Get(),rightDrawer()" 
            class="btn btn-primary" variant="primary"> 
            {{ $t("StrBirimButceHarcamalari.Filtreleme.Button") }}</b-button>
          </div>
        </div>
      </Drawer>
    </Layout>
  </Loader>
</template>
